module.exports = __webpack_public_path__ + "static/media/practise.714433b2.svg";